module.exports = __webpack_public_path__ + "img/app-regante.7605757c.png";